(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["restromart-card-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rm-card-cart')) {
    customElements.define('rm-card-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-rm-step]');
          if (!button) return;
          const input = this.querySelector('[name="quantity"]');
          if (!input.value || !Number.isFinite(input.valueAsNumber)) input.value = input.min || '1';
          if (button.dataset.rmStep === 'up') input.stepUp();
          else input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const form = this.querySelector('form');
        if (!form) return;
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (this.busy || !form.reportValidity()) return;
          this.busy = true;
          this.setAttribute('aria-busy', 'true');
          const submit = form.querySelector('[type="submit"]');
          const error = this.querySelector('[role="alert"]');
          error.hidden = true;
          submit.disabled = true;
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData(form);
          const scope = this.closest('.product-card-wrapper') || this.closest('.shopify-section');
          const quantity = Number(body.get('quantity')) || 1;
          const skidSelected = quantity >= 30;
          if (skidSelected) {
            body.set('quantity', String(quantity));
            body.set('properties[Purchase format]', 'Skid pricing (30+ cases)');
            body.set('properties[_restromart_pack]', 'skid');
          }
          const sections = cart?.getSectionsToRender?.() || [];
          if (sections.length) {
            body.append('sections', sections.map((section) => section.id).join(','));
            body.append('sections_url', window.location.pathname);
            cart.setActiveElement?.(submit);
          }
          try {
            const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
            const data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
            if (cart && sections.length && sections.every((section) => data.sections?.[section.id])) {
              try {
                cart.classList.remove('is-empty');
                cart.renderContents(data);
              } catch {
                window.location.assign(this.dataset.cartUrl);
              }
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
          } catch (failure) {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
          } finally {
            submit.disabled = false;
            this.busy = false;
            this.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
